import { render, staticRenderFns } from "./FundosTable.vue?vue&type=template&id=5f5bbf12&scoped=true"
import script from "./FundosTable.vue?vue&type=script&lang=js"
export * from "./FundosTable.vue?vue&type=script&lang=js"
import style0 from "./FundosTable.vue?vue&type=style&index=0&id=5f5bbf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5bbf12",
  null
  
)

export default component.exports